import { FolderItem, ItemType } from '@inno-sdks/files'
import { useMutation } from '@tanstack/react-query'

import { initFilesSdk } from '../filesSdk'
import { getAppFolderId } from '../getAppFolderId'

type CreateFolderParams = {
  name: string
  /** Defaults to the desktop's root app folder when omitted. */
  parentFolderId?: number
}

export const useCreateFolderMutation = () => {
  return useMutation({
    mutationFn: async ({ name, parentFolderId }: CreateFolderParams) => {
      const { filesSdk, success } = initFilesSdk()

      if (!success || !filesSdk) {
        throw new Error('Not authenticated')
      }

      const targetFolderId = parentFolderId ?? (await getAppFolderId())
      if (targetFolderId == null) {
        throw new Error('Could not resolve target folder')
      }

      const [folder] = await filesSdk.items.create(
        [{ type: ItemType.Folder, name }],
        targetFolderId
      )

      return folder as FolderItem
    }
  })
}
